import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Forgotmodel } from './forgotmodel';
import { environment } from 'src/environments/environment';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { sha256 } from 'js-sha256';

@Injectable({
  providedIn: 'root'
})
export class ForgotService {
  getlen: string;

  constructor(private http: HttpClient) {
    this.getlen = LocalstorageService.getLanguage("language");
  }

  public CheckEmail(data: Forgotmodel) {
    try {
      data.lan = this.getlen;
      let mydata = this.http.post<any>(`${environment.apiUrl}/TransistService/mobilesentotp?`, data)

  //    console.log(mydata);
      return mydata;

    } catch (error) {
//debugger;
      return;
    }

  }

  public CheckOTP(data: Forgotmodel) {
    data.lan = this.getlen;
    return this.http.post<any>(`${environment.apiUrl}/TransistService/mobileadminvalidateotp`, data)
  }

  public ResetPassword(data: Forgotmodel) {
    data.lan = this.getlen;
    //Changed - Password encrypted for Backend --23072020
    data.newpassword=sha256(data.newpassword);
    //Changed - Password encrypted for Backend --23072020

    return this.http.post<any>(`${environment.apiUrl}/TransistService/mobileadminupdatepassword`, data)
  }
}
